import { useState } from "react";
import { Form, Row, Col, Modal, Stack } from "react-bootstrap";
import GradientButton from "../Core/GradientButton";

export default function ChurnedServiceSalesAgentModal({modal, salesAgents}) {
    const [salesAgent, setSalesAgent] = useState(null);

    return (
        <Modal show={ modal.show } dialogClassName="td-admin" size="lg">
            <Modal.Header className="modal-admin-header">
                <div className="modal-admin-heading">Select Sales Agent</div>
            </Modal.Header>                
                <Modal.Body>
                    <Stack gap={3}>                        
                            <Form.Group as={Row}>
                                <Form.Label column sm={3}>Sales Agent</Form.Label>                                    
                                <Col sm={9}>
                                    <Form.Select className="form-control pe-5" onChange={e => setSalesAgent(e.target.value)}>
                                        <option value={""}>Select a Sales Agent</option>
                                            {salesAgents && salesAgents.map((agent) => (
                                                <option key={agent.Id} value={agent.Id}>
                                                    {agent.Code}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                    </Stack>
                </Modal.Body>
                <Modal.Footer>
                    <GradientButton title="Select" variant="greenYellow" disabled={!salesAgent} onClick={() => modal.onSelect(salesAgent)} className="mb-2" />
                    <GradientButton title="Cancel" variant="yellowOrange" onClick={modal.onClose} />
                </Modal.Footer>
        </Modal>
    )
}